<template>
    <div class="text-base mb-4 text-gray-600">
        {{__("Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another.")}}
    </div>

    <div class="mb-4 font-bold text-base text-green-600" v-if="verificationLinkSent" >
        {{__("A new verification link has been sent to the email address you provided during registration.")}}
    </div>

    <form @submit.prevent="submit">
        <div class="mt-4 flex items-center justify-between">
            <breeze-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{__("Resend Verification Email")}}
            </breeze-button>

            <InertiaLink :href="route('logout')" method="post" as="button" class="underline text-sm text-gray-600 hover:text-gray-900">{{__("Log Out")}}</InertiaLink>
        </div>
    </form>
</template>

<script>
    import BreezeButton from 'UI/Button'
    import BreezeGuestLayout from "@/Layouts/Guest"

    export default {
        layout: BreezeGuestLayout,

        components: {
            BreezeButton,
        },

        props: {
            status: String,
        },

        data() {
            return {
                form: this.$inertia.form()
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('verification.send'))
            },
        },

        computed: {
            verificationLinkSent() {
                return this.status === 'verification-link-sent';
            }
        }
    }
</script>
